import $ from 'jquery';
import Cookies from 'js-cookie';

const themeMode = Cookies.get( 'themeMode' );

if ( themeMode ) {
	if ( 'dark' === themeMode && $( 'body' ).hasClass( 'c-theme--light' ) ) {
		$( 'body' ).removeClass( 'c-theme--light' ).addClass( 'c-theme--dark' ).addClass( 'c-color--invert' );
	}

	if ( 'light' === themeMode && $( 'body' ).hasClass( 'c-theme--dark' ) ) {
		$( 'body' ).removeClass( 'c-theme--dark c-color--invert' ).addClass( 'c-theme--light' );
	}
} else {
	if ( window.matchMedia ) {
		if ( window.matchMedia( '(prefers-color-scheme: dark)' ).matches ) {
			$( 'body' ).removeClass( 'c-theme--light' ).addClass( 'c-theme--dark' ).addClass( 'c-color--invert' );
		} else {
			$( 'body' ).removeClass( 'c-theme--dark c-color--invert' ).addClass( 'c-theme--light' );	
		}

	} else {
		if ( $( 'body' ).hasClass( 'c-theme--dark' ) ) {
			$( 'body' ).removeClass( 'c-theme--dark c-color--invert' ).addClass( 'c-theme--light' );
		}
	}
}

if ( window.matchMedia ) {
	window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
		if (!Cookies.get( 'themeMode' )) {
			if ( e.matches ) {
				$( 'body' ).removeClass( 'c-theme--light' ).addClass( 'c-theme--dark' ).addClass( 'c-color--invert' );
			} else {
				$( 'body' ).removeClass( 'c-theme--dark c-color--invert' ).addClass( 'c-theme--light' );	
			}
		}
	});
}



/* Theme Switcher
********************************************/

$('.js-theme-switcher').on('click', function (e) {
	e.preventDefault();

	const themeMode = Cookies.get( 'themeMode' );

	if ( themeMode ) {
		if ( 'dark' === themeMode ) {
			Cookies.set( 'themeMode', 'light', { expires: 7 } );
		}

		if ( 'light' === themeMode ) {
			Cookies.set( 'themeMode', 'dark', { expires: 7 } );
		}
	} else {
		if ( $( 'body' ).hasClass( 'c-theme--dark' ) ) {
			Cookies.set( 'themeMode', 'light', { expires: 7 } );
		} else {
			Cookies.set( 'themeMode', 'dark', { expires: 7 } );
		}
		
	}

	$('body').toggleClass('c-theme--dark c-color--invert');
	$('body').toggleClass('c-theme--light');
});
